import { Log } from '../AuxillaryService/Log';
import { Signage, signageRebootSystem, signageReload } from '.';
import { ReachAPI } from '../ReachApi';
import { glom } from './glom';
import { $ } from '../../vendor/jquery';
import { moment } from '../../vendor/moment';

/**
 * Schedule Player Restart sometime between the given times
 * @param begin  Earliest restart time (Military time - H:mm:ss)
 * @param end    Latest restart time (Military time - H:mm:ss)
 */
export function schedulePlayerRestart(begin: string, end: string): void {
    let beginMoment;
    let endMoment;
    let restartMoment;
    let timeDifference;
    let randomOffset;
    let momentToRestart;
    const currentMoment = moment();

    if (begin && end) {
        beginMoment = moment(begin, 'HH:mm:ss', true);
        endMoment = moment(end, 'HH:mm:ss', true);

        if (beginMoment.isValid() && endMoment.isValid()) {
            if (endMoment.isAfter(beginMoment)) {
                timeDifference = moment.duration(endMoment.diff(beginMoment)).asMilliseconds();
            } else {
                timeDifference = 600000; // within ten minutes
            }

            //pick some random time between
            randomOffset = Math.floor(Math.random() * timeDifference);

            restartMoment = beginMoment.clone();
            restartMoment.add(randomOffset, 'milliseconds');
            if (beginMoment.isBefore(currentMoment)) {
                restartMoment.add(1, 'day');
            }

            momentToRestart = moment.duration(restartMoment.diff(currentMoment));

            Log.Info(
                'Player will attempt to restart in ' + momentToRestart.humanize(),
                null,
                __fileline,
                { restartOn: restartMoment.format('LLLL') }
            );

            setTimeout(requestRestart, momentToRestart.asMilliseconds());
        } else {
            Log.Error('Player daily restart is invalid', null, __fileline, {
                begin: begin,
                end: end,
            });
        }
    } else {
        Log.Error('Player daily restart not configured', null, __fileline, {
            begin: begin,
            end: end,
        });
    }
}

async function requestRestart(): Promise<void> {
    let restartOk = true;
    try {
        await $.ajax({
            type: 'GET',
            url: `${ReachAPI.server}/player/request_restart/${glom.playerUuid}`,
        });
    } catch {
        //try again in 5-10 minutes
        restartOk = false;

        const msecToRetry = Math.random() * (600000 - 300000) + 300000;
        setTimeout(requestRestart, msecToRetry);

        Log.Debug(
            `Restart request rejected, will try again in ${moment
                .duration(msecToRetry)
                .humanize()}`,
            null,
            __fileline
        );
    }

    if (restartOk) {
        //server says it's ok to restart now
        if (Signage.dailyReboot === 'true') {
            await signageRebootSystem();
        } else {
            await signageReload();
        }
    }
}
